import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { btnPrimary, btnOutline, eyebrow } from './WaLink';
import { img } from '../data/salon';
import './SalonResponsive.css';

const heroPhoto = 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/e17dff3e3c3e59e7665134ee72c6fa1c.webp';

function Hero() {
  return (
    <section className="hero-layout mx-auto grid max-w-[1280px] items-center gap-10 px-4 py-10 sm:px-6 lg:min-h-[680px] lg:gap-6 lg:py-14">
      <div className="hero-copy">
        <span className={eyebrow}>Luxury Beauty Studio · Agra</span>
        <h1 className="font-display mt-5 text-5xl leading-[1.05] text-[#0B3B36] sm:text-6xl lg:text-7xl">
          Where tradition meets <em className="text-[#C8553D]">radiance.</em>
        </h1>
        <p className="mt-5 max-w-md text-base text-[#4b5d59]">
          Bridal, hair and skin rituals crafted for you.
        </p>
      </div>

      <div className="hero-main-image relative mx-auto w-full max-w-[560px]">
        <div className="h-[460px] overflow-hidden rounded-t-[280px] rounded-b-2xl border-[10px] border-white shadow-2xl sm:h-[620px]">
          <img
            src={heroPhoto}
            alt="Indian woman with elegant makeup"
            className="h-full w-full object-cover object-[center_25%]"
          />
        </div>
        <div className="absolute -left-2 bottom-10 rounded-xl bg-[#E9A23B] px-5 py-4 text-[#0B3B36] shadow-xl sm:-left-8">
          <p className="font-display text-2xl leading-none">Open daily</p>
          <p className="mt-1 text-xs font-semibold">10 AM – 8 PM</p>
        </div>
      </div>

      <div className="hero-thumbnails grid max-w-md grid-cols-3 gap-3">
        {[img.heroA, img.heroB, img.care].map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Salon highlight ${index + 1}`}
            className="h-24 w-full rounded-lg object-cover sm:h-28"
          />
        ))}
      </div>

      <div className="hero-actions flex flex-wrap gap-3">
        <WaLink className={btnPrimary}>
          Book Appointment <SafeIcon icon={FiIcons.FiArrowUpRight} />
        </WaLink>
        <WaLink className={btnOutline}>Call +91 98765 43210</WaLink>
      </div>
    </section>
  );
}

export default Hero;
